// 单细胞项目 API
import {platformApi} from "@/axios";

// 最后10条
export function projectLast_10_eDNA(){
    return platformApi({
        url: '/platform-project/last-10',
        method: 'post',
        data:{'query#platform':'FISH_EDNA',
        }
    })
}

// 获取项目详情URL
export function projectDetailsUrl(id){
    return platformApi({
        url: '/platform-project/details/url/'+id,
        method: 'get',
    })
}

// 获取原始数据信息
export function projectRawDataInfo(id){
    return platformApi({
        url: '/platform-project/raw-data-info/url/'+id,
        method: 'get',
    })
}

// 获取样本信息
export function projectSampleInfo(id){
    return platformApi({
        url: '/platform-project/sample-list/'+id,
        method: 'get',
    })
}

// 获取项目详情信息
export function getProjectDetail(id){
    return platformApi({
        url: '/platform-project/information/'+id,
        method: 'get',
    })
}
